<div class="card-container-icon-text border-radius-sm" [class.card-container-active]="active" [class.small-card]="size === 'small'">
  <p class="text-info">
    <i *ngIf="hasInformation" class="icon-info" nz-icon nzType="info-circle" nzTheme="outline" nz-popover="" nzPopoverTitle=""
      [nzPopoverContent]="description"></i>
  </p>
  <div class="img">
    <img loading="lazy" [src]="value.img" alt="">
  </div>
  <div class="content">
    <div class="text-subtitle-bold" style="margin: 5px 0;">{{ value.label }}</div>
    <ng-content></ng-content>
  </div>
  <div class="card-container-icon-active" *ngIf="active" @fadeInAnimation>
    <img loading="lazy" src="./../../../assets/images/icons/icons8-checkmark-100.png" alt="">
  </div>
</div>
